import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import AnalysisTabs from "examples/Tabs/AnalysisTabs";

function BrandProfit() {
  return (
    <DashboardLayout>
      <AnalysisTabs />
    </DashboardLayout>
  );
}

export default BrandProfit;